module.exports = __webpack_public_path__ + "img/a1864c225eb0dac865a9205f3f98c018.png";